import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import { Navigate, useParams } from 'react-router-dom';

import { PublishedCMSBlogs } from '../../../../Data/Blogs/CMSBlogs';

import '../../Blog_Component/CSS_File/MainBlogPage.css';

import BlogAlsoRead from '../../Blog_Component/JS_File/BlogAlsoRead';
import BlogCommentForm from '../../Blog_Component/JS_File/BlogCommentForm';
import BlogSocialMediaIcon from '../../Blog_Component/JS_File/BlogSocialMediaIcon';

const DynamicBlogPage = () => {
    const { slug } = useParams();

    const blog = PublishedCMSBlogs.find(
    (blogData) => blogData.slug === slug
);

    const contentRef = useRef(null);
    const [readingTime, setReadingTime] = useState("01");

    useEffect(() => {
        if (!contentRef.current) {
            return;
        }

        const text = contentRef.current.innerText.trim();

        const wordCount = text
            ? text.split(/\s+/).filter(Boolean).length
            : 0;

        const wordsPerMinute = 250;

        let time = Math.ceil(wordCount / wordsPerMinute);

        if (time < 10) {
            time = "0" + time;
        }

        setReadingTime(time);
    }, [blog]);

    if (!blog) {
        return <Navigate to="/blog" replace />;
    }

    const canonicalUrl =
        `https://www.writemydissertationforme.com/blogPage/${blog.slug}`;

    const imageUrl = blog.blogImage?.startsWith("http")
        ? blog.blogImage
        : `https://www.writemydissertationforme.com${blog.blogImage}`;

    const publishedDate = blog.date;

    const formattedDate = publishedDate
        ? new Date(`${publishedDate}T00:00:00`).toLocaleDateString(
            "en-US",
            {
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        )
        : "";

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",

        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": canonicalUrl
        },

        "headline": blog.title,

        "description": blog.metaDescription || blog.description,

        "image": imageUrl,

        "author": {
            "@type": "Organization",
            "name": "Write My Dissertation For Me",
            "url": "https://www.writemydissertationforme.com/"
        },

        "publisher": {
            "@type": "Organization",
            "name": "Write My Dissertation For Me",
            "url": "https://www.writemydissertationforme.com/"
        },

        "datePublished": publishedDate,

        "dateModified": publishedDate
    };

    return (
        <>
            <Helmet>

                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>

                <title>
                    {`Blog | ${blog.title}`}
                </title>

                <meta
                    name="description"
                    content={blog.metaDescription || blog.description}
                />

                <link
                    rel="canonical"
                    href={canonicalUrl}
                />

            </Helmet>

            <section className="blogPageStartHere">

                <div className="container blogPageInnerDivStartHere">

                    <div className="row justify-content-center">

                        <div className="col-md-12 blogTitleDateAndReadTime">

                            <h1>
                                {blog.title}
                            </h1>

                            <p>
                                <span>
                                    {formattedDate}
                                </span>

                                {" | "}

                                <span id="dissertationLiteratureReview">
                                    {readingTime} min read
                                </span>
                            </p>

                        </div>

                        <div className="col-md-12 blogImageDiv">

                            <img
                                src={blog.blogImage}
                                alt={blog.altTag || blog.title}
                                className="img-fluid"
                            />

                        </div>

                        <div
                            className="col-md-12 blogPageContentFirst pb-0"
                            ref={contentRef}
                        >

                            <ReactMarkdown>
                                {blog.body || ""}
                            </ReactMarkdown>

                        </div>

                        <BlogSocialMediaIcon />

                    </div>

                </div>

            </section>

            <BlogCommentForm />

            <BlogAlsoRead />

        </>
    );
};

export default DynamicBlogPage;